import Validators from "redux-form-validators";

export const required = value => (value ? undefined : "Required");

export const regex = {
  alphaNumeric: /^[a-z0-9]+$/i,
  alphaNumericSpace: /^[a-z0-9\s]+$/i,
  letters: /^[a-z]+$/i,
  min8Characters: /^.{8,}$/i,
  lowercaseLetter: /[a-z]+/,
  uppercaseLetter: /[A-Z]+/,
  numberOrSpecialCharacter: /[\d!@#$%^&;()_+}{':;?/.<>=]/,
};

export const messages = {
  alphaNumeric: "Only allows letters and numbers",
  alphaNumericSpace: "Only allows letters, numbers and whitespaces",
  letters: "Only allows letters",
};

const overrideMessages = () =>
  Object.assign(Validators.messages, {
    email: "is not a valid email address",
    presence: "This field is required",
    greaterThanOrEqualTo: "You must enter a valid positive number",
  });

export const wrapperValidate = validations => (values, allValues, props) => {
  overrideMessages();
  const errors = {};
  for (let field in validations) {
    let value = values[field];
    errors[field] = validations[field]
      .map(validateField => {
        return validateField(value, values);
      })
      .find(x => x);
  }
  return errors;
};
